import React, { useContext } from "react";
import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import DeleteModal from "components/modal/DeleteModal";
import MainDrawer from "components/drawer/MainDrawer";
import EditDeleteButton from "components/table/EditDeleteButton";
import useToggleDrawer from "hooks/useToggleDrawer";
import TollDrawer from "components/drawer/TollDrawer";
import Tooltip from "components/tooltip/Tooltip";
import { FiEye } from "react-icons/fi";
import ViewTollModel from "components/modal/ViewTollModel";
import ActiveMenu from "components/table/ActiveMenu";
import TollServices from "services/TollServices";
import { notifyError, notifySuccess } from "utils/toast";
import { SidebarContext } from "context/SidebarContext";

const TollTable = ({
  hideView,
  hideEdit,
  hideAdd,
  hideDelete,
  hideExport,
  tolldata,
}) => {
  const {
    title,
    serviceId,
    handleModalOpen,
    handleUpdate,
    handleView,
    handleMenuDetails,
  } = useToggleDrawer();
  // console.log("id for toll", serviceId);
  const { setIsUpdate } = useContext(SidebarContext);

  const handleStatus = async (id, currentStatus, titleActive) => {
    // const newStatus = currentStatus === "true" ? true : false;
    const newStatus = !currentStatus;
    try {
      const response = await TollServices.updateTollStatus(id, {
        status: newStatus,
      });
      if (response.status) {
        notifySuccess(`Status Updated Successfully`);
        setIsUpdate(true);
      } else {
        notifyError("Failed to update status");
      }
    } catch (error) {
      notifyError("An error occurred while updating status");
      console.error(error);
    }
  };

  return (
    <>
      <ViewTollModel id={serviceId} title={title} data={tolldata} />
      <DeleteModal id={serviceId} title={title} />

      <MainDrawer>
        <TollDrawer id={serviceId} />
      </MainDrawer>

      <TableBody>
        {tolldata?.map((data, index) => (
          <TableRow key={data.toll_id}>
            <TableCell className="text-center text-xs">{index + 1}</TableCell>
            <TableCell className="text-center text-xs">
              {data.toll_name}
            </TableCell>
            <TableCell className="text-center text-xs">
              {data.state_name}
            </TableCell>
            <TableCell className="text-center text-xs">
              {data.city_name}
            </TableCell>
            <TableCell className="text-center text-xs">{data?.sedan?.tag_price ?? '-'}</TableCell>
            <TableCell className="text-center text-xs">{data.suv?.tag_price ?? '-'}</TableCell>
            <TableCell className="text-center text-xs">
              {data.tempo_traveller?.tag_price ?? '-'}
            </TableCell>
            <TableCell className="text-center">
              <ActiveMenu
                id={data.toll_id}
                active={data.status}
                title_active={"Active"}
                handleMenu={handleStatus}
              />
            </TableCell>
            <TableCell className="text-center text-xs">
              <div className="flex justify-center">
                <button
                  onClick={() => handleMenuDetails(data.toll_id, "Toll Details")}
                  className="p-2 cursor-pointer text-gray-400 hover:text-red-600 focus:outline-none"
                >
                  <Tooltip
                    id={data.toll_id}
                    Icon={FiEye}
                    title="ViewOrder"
                    bgColor="#34D399"
                  />
                </button>

                <EditDeleteButton
                  title={data.toll_name}
                  id={data.toll_id}
                  handleUpdate={handleUpdate}
                  handleModalOpen={handleModalOpen}
                  handleView={handleView}
                  hideEdit={hideEdit}
                  hideView={hideView}
                  hideAdd={hideAdd}
                  hideDelete={hideDelete}
                  hideExport={hideExport}
                />
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default TollTable;
